import { ref } from 'vue';
import http from '@/http.js';
import eventBus from '@/eventBus.js';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function useAnomaliesItem(props) {
    const showModalValidJustifAnomalie = ref(false);
    const showModalEditerJustifAnomalie = ref(false);
    const anomalie = ref({});
    const commentaire = ref('Refus de la justification');

    props.anomalies.forEach((anomalie) => {
        anomalie.showModalValidJustifAnomalie = false;
        anomalie.showModalEditerJustifAnomalie = false;
    });

    const ValidJustif = async (valid, commentaire, idLigneAnomalie) => {
        try {
            const data = await http.validJustif(valid, commentaire, idLigneAnomalie);
            idLigneAnomalie = data;

            eventBus.emit('reloadAnomaliesToJustif');
            eventBus.emit('reloadRequete');
            eventBus.emit('reloadRapport');
        } catch (error) {
            console.error('Error validating justification:', error);
        }
    };

    return {
        showModalValidJustifAnomalie,
        showModalEditerJustifAnomalie,
        anomalie,
        commentaire,
        ValidJustif,
    };
}